<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import { useSiteLocale } from './composables/useSiteLocale'
import { applySeo } from './app/seo'
import SiteFooter from './components/site/SiteFooter.vue'
import SiteNav from './components/site/SiteNav.vue'

const menuOpen = ref(false)
const route = useRoute()
const { currentLocale } = useSiteLocale()
watch([() => route.path, currentLocale], ([path, locale]) => applySeo(path, locale), { immediate: true })
const isHome = computed(() => route.name === 'home')
const isDownload = computed(() => route.name === 'download' || route.name === 'download-page')
</script>

<template>
  <div class="site-app" :class="{ 'site-app--download': isDownload }">
    <SiteNav v-if="!isHome" v-model:open="menuOpen" />
    <main @click="menuOpen = false">
      <RouterView />
    </main>
    <SiteFooter v-if="!isHome" />
  </div>
</template>
